import Component from '../abstracts/Component';

export default class SearchGuestOrderComponent extends Component {

  get SELECTORS() {
    return {
      btnSearch: '[data-search-order]',
    };
  }

  get CLASSES() {
    return {
      errorClass: 'error',
      customInput: 'custom-input'
    }
  }

  searchOrderSubmit() {

    //ajax submit of search order form to manage errors
    const ctx=this;
    $('body').on('click.search-order',SearchGuestOrderComponent.SELECTORS.btnSearch,function (e) {
      e.preventDefault();
      let formSearchOrder = this.closest('form');
      const formData = ctx.getFormData(formSearchOrder);
      let contextPath = document.getElementsByTagName('HTML')[0].getAttribute("data-context");
      $.ajax({
        url: contextPath + '/guest/return-request?search-guest-order=true',
        data: formData,
        method: 'POST',
        success: function (response) {
          if(response.hasError){
            // $('.js-error-notification').removeClass('--hidden');
            $(formSearchOrder).find(ctx.CLASSES.customInput).addClass(ctx.CLASSES.errorClass);
          } else {
            // $('.js-error-notification').addClass('--hidden');
            $(formSearchOrder).find(ctx.CLASSES.customInput).removeClass(ctx.CLASSES.errorClass);
            $(formSearchOrder).submit();
          }
        }
      })
    });

  }

  getFormData(formSearchOrder) {
    return $(formSearchOrder).serialize();
  }

  render() {
    super.render();
    this.searchOrderSubmit();
  }
}
